"use strict";

// tweaks these below variable if you want to show subtotal and discount
var showCartSubTotalDiscountSection = true;
var showEmptyCartIcon = false;
var showCartCountInTopNav = true;
var showProgressBar = true;
var showVendorOnCartPage = false; // Fixed variables

var lineItemComparePrice;
var cartObject;
var cartCountEmptyValue = "0";
var boxID = "BuilderID";
var cartExtraInfo; //extra classes for the elements

var removeExtraClass = "btn-border-black-animate"; // recharge 2020

var frequency = "";
var recurringchecked = false;
var frequency_unit = ""; //SVG icons

var removeMiniCartTextOrIcon = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">    <path fill-rule="evenodd" clip-rule="evenodd" d="m5.815 7.586 4.188 4.188 1.523-1.523-4.188-4.188 4.189-4.189L10.004.351 5.814 4.54 1.628.352.104 1.875l4.188 4.188-4.188 4.188 1.523 1.523 4.188-4.188z" fill="#1A1B1B"/> </svg>';
var minusIcon = '';
var plusIcon = '';
$(document).ready(function ($) {
  reloadAjaxCartItemUsingCartAjaxObject();
  progressBar();
  quickCartTotal(); //	window.location.href = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=XXX.myshopify.com";
  //window.location = '/checkout';
});
/*
EVENTS
1. Update quantity
2. remove item from cart
3. reload ajax cart
4. quickCartTotal
5. cart.requestComplete
*/
//QUANTITY UPDATE

function updateCartQuantity(cartThis) {
  var id = $(cartThis).attr("data-variant-id");
  var quantity = $("#updates_" + id).val();
  var type = $(cartThis).attr("date-type");
  var newQuantity = parseInt(quantity);

  if (type == "plus") {
    newQuantity = newQuantity + 1;
  } else {
    if (newQuantity > 0) {
      newQuantity = newQuantity - 1;
    }
  }

  var formData = {
    updates: {}
  };
  formData.updates[id] = newQuantity; // Perform the AJAX request to update the cart

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: formData,
    dataType: "json",
    success: function success(cart) {
      // Perform any additional tasks after removing items
      $("#updates_" + id).val(newQuantity);
      getCartData(cart);
    },
    error: function error(_error) {
      // Handle error if the request fails
      console.error("Error updating items from the cart:", _error);
    }
  });
}
/* If you need extra information like collection title, metafield etc then use this function */


function reloadAjaxCartItemUsingCartAjaxObject(data) {
  //   cartInfo(data);
  $.ajax({
    type: "GET",
    url: "/cart?view=alternate.json",
    success: function success(response) {
      //extra information against the cart like collection title metafield, product title metafield, tags
      cartExtraInfo = $.parseJSON(response);
      cartInfo(data); // Populate addon products

      populateAddonProducts(cartExtraInfo);
    },
    error: function error(status) {
      console.warn("ERROR", status);
      cartInfo(data);
    }
  });
} // Populate addon products in cart drawer and cart page


function populateAddonProducts(cartExtraInfo) {
  if (!cartExtraInfo || !cartExtraInfo.addons || cartExtraInfo.addons.length === 0) {
    $(".js__addon-products-wrapper").html("");
    $(".js__cart-page-addon-wrapper").html("");
    $(".js__cart-page-addon-product").hide();
    $(".js__cart-minicart-addon-product").hide();
    return;
  } // Get array of variant IDs already in cart - convert to string for consistency


  var cartVariantIds = [];

  if (cartExtraInfo.items && cartExtraInfo.items.length > 0) {
    $.each(cartExtraInfo.items, function (index, item) {
      if (item.id) {
        cartVariantIds.push(String(item.id));
      }
    });
  }

  var addonHTML = ""; // For cart drawer (swiper format)

  var cartPageAddonHTML = ""; // For cart page (flex-wrap format)

  var processedAddonIds = []; // Track addon IDs already processed to avoid duplicates

  var addonDisplayLimit = 3; // Show at most this many addons

  var displayedAddonCount = 0;
  $.each(cartExtraInfo.addons, function (index, addon) {
    // Skip if this addon is already in the cart - convert to string for consistency
    var addonIdStr = String(addon.id);

    if ($.inArray(addonIdStr, cartVariantIds) !== -1) {
      return true; // continue to next iteration
    } // Skip if this addon ID has already been processed in this iteration


    if ($.inArray(addonIdStr, processedAddonIds) !== -1) {
      return true; // continue to next iteration
    } // Mark this addon as processed


    processedAddonIds.push(addonIdStr);
    var price = formatter.format(addon.variant_price / 100); // HTML for cart drawer (swiper-slide format)

    var addonHTMLItem = '<li >';
    addonHTMLItem += '<div class="image-section">';
    addonHTMLItem += '<img src="' + addon.productImage + '" alt="' + addon.product_title + '">';
    addonHTMLItem += '</div>';
    addonHTMLItem += '<div class="content">';
    addonHTMLItem += '<span class="name">' + addon.product_title + '</span>';
    addonHTMLItem += '<span class="price">' + price + '</span>';
    addonHTMLItem += '<a href="javascript:;" class="link--secondary js__addon-add-to-cart" data-attr-variantid="' + addon.id + '">+Add</a>';
    addonHTMLItem += '</div>';
    addonHTMLItem += '</li>'; // HTML for cart page (flex format)

    var cartPageItem = '<li>';
    cartPageItem += '<div class="image-section">';
    cartPageItem += '<img src="' + addon.productImage + '" alt="' + addon.product_title + '">';
    cartPageItem += '</div>';
    cartPageItem += '<div class="content">';
    cartPageItem += '<span class="name">' + addon.product_title + '</span>';
    cartPageItem += '<span class="price">' + price + '</span>';
    cartPageItem += '<a href="javascript:;" class="link--secondary js__addon-add-to-cart" data-attr-variantid="' + addon.id + '">+Add</a>';
    cartPageItem += '</div>';
    cartPageItem += '</li>';
    addonHTML += addonHTMLItem;
    cartPageAddonHTML += cartPageItem;
    displayedAddonCount += 1; // Stop once we reach the display limit

    if (displayedAddonCount >= addonDisplayLimit) {
      return false; // break out of $.each loop
    }
  }); // Populate cart drawer

  $(".js__addon-products-wrapper").html(addonHTML); // Populate cart page

  if (cartPageAddonHTML !== "") {
    $(".js__cart-page-addon-wrapper").html(cartPageAddonHTML);
    $(".js__cart-page-addon-product").show();
    $(".js__cart-minicart-addon-product").show();
  } else {
    $(".js__cart-page-addon-wrapper").html("");
    $(".js__cart-page-addon-product").hide();
    $(".js__cart-minicart-addon-product").hide();
  } // Initialize the swiper if it exists (for cart drawer)


  if (typeof Swiper !== 'undefined') {
    /* Hero Banner SLider */
    var addonProducts = new Swiper(".js_addon-products-slider", {
      slidesPerView: 1,
      resistance: false,
      autoHeight: true,
      loop: false,
      // autoplay: {
      //     delay: 10000,
      // },
      // Navigation arrows
      pagination: {
        el: ".swiper-pagination-addon-product",
        clickable: true
      }
    });
  }
} //RELOAD AJAX CART


function cartInfo(data) {
  var lineCount = 1;
  var cartObject;

  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
    quickCartTotal(data);
  }

  $(".js__ajax-products-bind").html("");
  $(".js__ajax-products-bind").removeClass("empty");
  $(".cart-list").html("");

  if (cartObject.items.length == 0) {
    $(".empty-cart-section").show();
    $(".template-cart").find(".four-column-reviews").hide();
    $(".js__show-cart-items-section").hide();
    $(".js__top-cart-form-actions").hide();
    $(".js__ajax-products-bind").html("<li>Your Cart is Empty</li>");
    $(".js__ajax-products-bind").addClass("empty");
  } else {
    $(".js__top-cart-form-actions").show();
    $(cartObject.items).each(function () {
      var imageURL = this.featured_image.url; //imageURL = imageURL[0] + "." + imageURL[1] + '_450x450' + "." + imageURL[2];

      var imageAlt = this.featured_image.alt;
      var itemPrice = this.original_price;
      var itemLinePriceTotal = this.line_price;
      var handle = this.handle;
      var itemID = this.id;
      var itemPriceAfterDiscount = this.discounted_price;
      var comparePrice = "";
      var disabled = "";
      var finalLineItemPrice = this.final_line_price;
      var cartBundleBoxID = "";
      var boolPromoOffer = false;
      var productTitle = this.product_title;
      var url = this.url;
      var itemProperties = "";
      var itemPropertiesElement = "";
      var boolItemBoxType = false;
      var hideElementClass = "";
      var readonly = "";
      var justifyCenter = "";
      var sellingPlayInformation = "";

      if (this.selling_plan_allocation != undefined) {
        sellingPlayInformation = this.selling_plan_allocation.selling_plan.name;
      }

      if (this.properties != null) {
        itemProperties = this.properties;

        if (Object.keys(itemProperties).length > 0) {
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID) {
              cartBundleBoxID = value;
            }

            if (key == "_ProductUrl") {
              url = value;
            }

            if (key == "_promoOffer") {
              boolPromoOffer = true;
            }
          });
          /* Checking the Box ID for the builder */

          itemPropertiesElement = "<ul>";
          $.each(itemProperties, function (key, value) {
            /* If box ID exists, then remove quantity + -  working */
            if (key == boxID || key == "_FreeGift") {
              hideElementClass = "hide";
              readonly = "readonly='readonly'";
              boolItemBoxType = true;
              justifyCenter = "justify-center ";
              url = "javascript:;";
            }

            if (key.indexOf("_") > -1) {} else {
              if (key != boxID) {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              } else {
                itemPropertiesElement += "<li class='flex'><span>" + key + ": </span><span style='padding-left: 5px'>" + value + "</span>";
                itemPropertiesElement += "</li>";
              }
            } // Recharge - when subscription is via properties for older recharge version before November 2020


            recharge2020(key, value);
          }); // Recharge 2020, check if it's a subscription, then bind the value in the UL

          if (recurringchecked) {
            itemPropertiesElement += "<li class='flex'><span>Recurring Delivery every " + frequency + " " + frequency_unit + ". Change or cancel anytime</span>";
            itemPropertiesElement += "</li>";
          }

          itemPropertiesElement += "</ul>";
        } else {//itemPropertiesElement = "";
        }
      }

      var rechargeSelected = this.selling_plan_allocation;
      var rechargeDropdown = "";
      /* Loop through cartExtraInformation section */

      $(cartExtraInfo.items).each(function (key, value) {
        if (value.id == itemID) {
          if (value.comparePrice != null) {
            comparePrice = value.comparePrice;
          }

          if (value.productImage != null) {
            imageURL = value.productImage;
          }

          var Quantity = value.quantity;

          if (value.product_recharge == "True") {
            if (rechargeSelected == undefined) {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + Quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'><option value=" + value.product_rechargeID + ">" + value.product_rechargeName + "</option><option value='One Time Purchase' selected>One Time Purchase</option></select>";
            } else {
              rechargeDropdown = "<select id='planID" + lineCount + "' data-qty=" + this.quantity + " class='" + hideElementClass + " custom-dropdown-select js__cart-plan'><option value=" + value.product_rechargeID + " selected>" + value.product_rechargeName + "</option><option value='One Time Purchase'>One Time Purchase</option></select>";
            }
          }

          productTitle = "<h5 class'h6'> <a href='" + url + "' id='product-card-" + this.id + "' tabindex='0'>" + value.product_title.split("with")[0] + " </a></h5>";
        }
      });
      /* get compare price using cartLib object */
      // if (typeof cartLib !== "undefined") {
      //           $.each(cartLib, function(key, value) {
      //               //console.log(value);
      //               if (value["id"] == itemID) {
      //                   comparePrice = value["comparePrice"];
      //               }
      //           });
      //       }

      /* FORMATTED PRICING */

      var formattedcomparePrice = formatter.format(comparePrice / 100);
      var comparePriceHtml = "";

      if (comparePrice > parseFloat(itemPrice)) {
        comparePriceHtml = "<s>" + formattedcomparePrice + "</s>";
      } // total compared price for the item with quantity


      var totalListItemComparePriceHtml = "";
      var totalListItemComparePrice = formatter.format(comparePrice * this.quantity / 100);

      if (comparePrice > 0) {
        var totalListItemComparePriceHtml = "<s>" + totalListItemComparePrice + "</s>";
      } // item original price


      var formattedItemPrice = formatter.format(itemPrice / 100); // line price

      var formattedItemLinePriceTotal = formatter.format(itemLinePriceTotal / 100); //final line item price

      var formattedFinalLineItemPrice = formatter.format(finalLineItemPrice / 100); //Price after discount

      var showPrice = "";
      var itemPriceAfterDiscountStatus = false;
      var discountedMessage = "";
      var discountedMessageElement = "";

      if (this.discounts != null) {
        discountedMessage = this.discounts;

        if (Object.keys(discountedMessage).length > 0) {
          //console.log("DISCOUNT EXISTS");
          discountedMessageElement = "<span class='discountedMessage'>";
          $.each(discountedMessage, function (key, value) {
            discountedMessageElement += value.title;
          });
          discountedMessageElement += "</span>";
        }
      }

      var formattedItemPriceAfterDiscount = formatter.format(itemPriceAfterDiscount / 100); // if itemPriceAfterDiscount > 0 then set the status to true so you can interchange the values

      if (this.discounts.length > 0) {
        itemPriceAfterDiscountStatus = true;
      } // if it's true; then show the compared price as the main price this.price and main price as discounted price


      if (itemPriceAfterDiscountStatus) {
        //comparePriceHtml
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0"><s>' + formattedItemPrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemPriceAfterDiscount + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>" + discountedMessageElement;
      } else {
        showPrice = '<span class="price-wrapper js__raw-line-item-price"  data-attr-compare-price="0">' + comparePriceHtml + '<span class="price" data-key="' + itemID + '">' + formattedItemPrice + "</span><span class='forMiniCart'>" + formattedFinalLineItemPrice + "</span></span>";
      }
      /* check if variantTitle is NULL, then don't show variant */


      var variantTitle = this.variant_title;

      if (variantTitle == null) {
        variantTitle = "";
      }

      var variantData = "";
      $.each(this.options_with_values, function (key, value) {
        //console.log("key" + key);console.log("value" + value["name"]);console.log("value" + value["value"]);
        variantData += "<li><span>" + value["name"] + ": " + value["value"].split("with")[0] + "</span></li>";
      });
      /* CUSTOM - if the product title contains "bag",  then disabled the quantity element
          To be applied for all the products with BoxID and Promo Offer
          */

      if (this.product_title.toLowerCase().indexOf("bag") >= 0 && cartBundleBoxID != "" || this.product_title.toLowerCase().indexOf("bag") >= 0 && boolPromoOffer) {
        //if you want to hide the quantity + - then enable the class below
        // hideElementClass="hide"
        justifyCenter = "justify-center ";
        readonly = "readonly='readonly'";
        disabled = "disabled ";
      }
      /* 
      LINE ITEM FOR THE MINI CART
      */
      // remove anchor
      //quantity element


      var quantityElement = '<div class="cart-quantity-outer ' + disabled + justifyCenter + '"> <a  tabindex="0"  class="minus-qty ' + hideElementClass + '  font-zero" date-type="minus" onclick="updateCartQuantity(this)"   data-variant-id="' + itemID + '">' + minusIcon + '</a> <input aria-label="Quantity"  tabindex="-1"  data-limit="' + boolItemBoxType + '"  ' + readonly + '   onkeydown="return isNumeric(event);" type="text"  data-attr-raw-variant-quantity="94" data-cart-line-count="' + lineCount + '" class="cart__quantity-selector js__cart__quantity-selector" name="updates[]" id="updates_' + itemID + '" value="' + this.quantity + '" maxlength="3" size="3"> <a  tabindex="0"  class="plus-qty ' + hideElementClass + '  font-zero" date-type="plus" onclick="updateCartQuantity(this)"     data-variant-id="' + itemID + '">' + plusIcon + "</a> </div>"; //vendor element

      var vendorElement = '<span class="subheading uppercase">' + this.vendor + "</span>";
      var lineItem;
      lineItem = '<li class="flex-wrap js__cart-table-item-row" data-cart-line-count=' + lineCount + ' data-handle="' + handle + '" data-variant-id=' + itemID + '><div class="image-section"> <a href="' + url + '"><img alt="' + imageAlt + '" src="' + imageURL + '""> </a> </div>';
      lineItem += '<div class="content"><div class="title-section">' + productTitle + "";

      if (sellingPlayInformation != "") {
        lineItem += '<p class="capitalize">' + sellingPlayInformation + "</p>";
      }

      if (itemPropertiesElement != "") {
        lineItem += '<p class="capitalize">' + itemPropertiesElement + "</p>";
      }

      if (variantTitle != "") {
        lineItem += "<ul>" + variantData + "</ul>";
      }

      lineItem += showPrice + '</div><div class="flex-space-between"><div class="quantity-remove-outer">' + quantityElement + '</div>';
      lineItem += "<span class='price'>" + formattedItemLinePriceTotal + totalListItemComparePriceHtml + "</span></div><a class='remove' data-cart-line-count='" + lineCount + "' data-variant-id='" + itemID + "' href='javascript:;'>remove</a></div>";
      lineItem += "</li>";
      /* Bind the line item to the list */

      $(".js__ajax-products-bind").append(lineItem);
      /*******LINE ITEM FOR THE CART PAGE********/

      if ($(".cart-list")[0]) {
        var cartLineItem = "";
        cartLineItem = '<div class="cart-list__items cart-table-body js__cart-table-item-row flex" data-cart-line-count="' + lineCount + '" data-attr-compare-price="" data-variant-id="' + itemID + '"><div class="cart-list__items__columns"><a class="image-section " href="' + url + '"><img class="img-responsive img-thumbnail item-image" src="' + imageURL + '" alt="' + imageAlt + '"></a> <div class="content">'; // show vendor on cart page

        if (showVendorOnCartPage) {
          cartLineItem += vendorElement;
        }

        cartLineItem += productTitle;
        cartLineItem += '<div class="cart-list__variant-properties">';

        if (sellingPlayInformation != "") {
          cartLineItem += '<span class="capitalize">' + sellingPlayInformation + "</span>";
        }

        if (itemPropertiesElement != "") {
          cartLineItem += '<span class="capitalize">' + itemPropertiesElement + "</span>";
        }

        if (variantTitle != "") {
          cartLineItem += "<ul>" + variantData + "</ul>";
        }

        cartLineItem += showPrice + "</div>";
        cartLineItem += '<a class="remove" data-cart-line-count="' + lineCount + '" data-variant-id="' + itemID + '" href="javascript:;">remove</a></div>  </div> ';
        cartLineItem += '<div class="cart-list__items__columns price" > ' + showPrice; // ** Remove action is added here too

        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns quantity" data-variant-id="' + itemID + '"> ' + quantityElement + '   <span class="js__out-of-stock"></span>'; // ** Remove action is added here too

        cartLineItem += "</div>";
        cartLineItem += '<div class="cart-list__items__columns total-price " data-head="Total"> <span class="price-wrapper js__set-line-item-price" data-attr-price="' + itemPrice + '" data-attr-compare-price=' + totalListItemComparePrice + '><s class="hide">' + totalListItemComparePrice + '</s><span class="price" data-key="' + itemID + '">' + formattedItemLinePriceTotal + "</span> </span>"; // ** Remove element is added here too

        cartCountEmptyValue += " </div></div>";
        $(".cart-list").append(cartLineItem);
      }

      lineCount++;
    });
  }
} //CALCULATE TOTAL OF THE CART


function quickCartTotal(data) {
  if (data == undefined) {
    cartObject = CartJS.cart;
  } else {
    cartObject = data;
  }

  var total = cartObject.items_subtotal_price;
  total = total / 100;
  total = formatter.format(total);
  $(".js__cart-sub-total").html(total);
  $(".js__cart-total").html(total);
  $(".js__ajax-cart-total").html("" + total);
  $(".js__ajax-cart-total").show();
  $(".js__ajax-cart-count").html(cartObject.item_count);
  $(".js__top-cart-form-actions").show();
  $(".js__cart-expand ").removeClass("empty-cart");
}
/* REMOVE */


var savedItemPropertyBoxID = "";
$(document).on("click", ".remove", function () {
  var variantID = parseInt($(this).attr("data-variant-id"));
  var clickedLineItemCount = parseInt($(this).attr("data-cart-line-count"));
  var currentLoopItemCount = 1; // console.log(variantID);

  var boxID = "BuilderID";
  var itemsToRemove = [];
  var formData = {
    updates: {}
  };
  $.getJSON("/cart.js", function (cart) {
    var savedItemPropertyBoxID = ""; // console.log(cart.items.length);
    // Find the item with the matching variantID and save its BoxID property

    for (var i = 0; i < cart.items.length; i++) {
      if (clickedLineItemCount === currentLoopItemCount) {
        var currentItem = cart.items[i];

        if (currentItem.variant_id === variantID) {
          // console.log(currentItem);
          // console.log(currentItem.variant_id);
          // console.log("variant ID matches");
          // console.log(currentItem.properties);
          // console.log(currentItem.properties[boxID]);
          if (currentItem.properties && currentItem.properties[boxID]) {
            savedItemPropertyBoxID = currentItem.properties[boxID]; // console.log("Saved Item Property Box ID:", savedItemPropertyBoxID);

            break;
          } else {
            // it doesn't has the BoxID, then delete the particular LineItem
            // console.log("Current Line Item - With no BoxID")
            itemsToRemove.push(currentItem.variant_id);
          }
        }
      }

      currentLoopItemCount = currentLoopItemCount + 1;
    } // Loop through cart items to find items with matching BoxID


    for (var j = 0; j < cart.items.length; j++) {
      var currentItem = cart.items[j];

      if (currentItem.properties && currentItem.properties[boxID] === savedItemPropertyBoxID) {
        itemsToRemove.push(currentItem.variant_id); //console.log("Item Variant ID to Remove:", currentItem.variant_id);
      }
    } // console.log(itemsToRemove);
    // console.log(itemsToRemove.length);
    // Call the function to remove items from the cart


    removeItemsFromCart(itemsToRemove); // Remove items from the cart
  });
}); // Function to remove items from the cart

function removeItemsFromCart(itemsToRemove) {
  var formData = {
    updates: {}
  }; // Populate the formData with variant IDs to remove

  for (var k = 0; k < itemsToRemove.length; k++) {
    var variantID = itemsToRemove[k];
    formData.updates[variantID] = 0;
  }

  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: formData,
    dataType: "json",
    success: function success(cart) {
      getCartData(cart);
    },
    error: function error(_error2) {
      // Handle error if the request fails
      console.error("Error removing items from the cart:", _error2);
    }
  });
}

function getCartData() {
  $.getJSON("/cart.js", function (cart) {
    cartInfo(cart);
    progressBar(); // Reload addon products to refresh the list after cart updates

    $.ajax({
      type: "GET",
      url: "/cart?view=alternate.json",
      success: function success(response) {
        cartExtraInfo = $.parseJSON(response);
        populateAddonProducts(cartExtraInfo);
      },
      error: function error(status) {
        console.warn("ERROR fetching addon products", status);
      }
    });
    setTimeout(function () {
      addons();
    }, 1000);
  });
}
/*
PROGRESS BAR
*/


function progressBar() {
  var totalAmount = 0;
  var shippingGrandTotal = 0;

  if (showProgressBar) {
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json"
      }
    }).then(function (res) {
      return res.json();
    }).then(function (data) {
      totalAmount = data.total_price / 100;
      var freeShippingAmount = parseFloat($(".js__free-shipping-limit").html());
      shippingGrandTotal = freeShippingAmount;
      var freeShippingRemaningAmount = freeShippingAmount - totalAmount;
      var freeShippingPercentage = 100;

      if (freeShippingRemaningAmount > 0) {
        freeShippingPercentage = totalAmount * 100 / freeShippingAmount;
        $(".js__free-shipping-limit-message").show();
        $(".js__free-shipping-message").hide();
        $(".js__free-shipping").hide();
        $(".js__CartShipping").addClass("hide");
      } else {
        $(".js__CartShipping").removeClass("hide");
        $(".js__free-shipping-limit-message").hide();
        $(".js__free-shipping-message").show();
        $(".js__free-shipping").show();
      }

      $(".js__free-shipping-remaning-amount").html(formatter.format(freeShippingRemaningAmount));
      $(".js__free-shipping__progress-bar").attr("data-percentage", freeShippingPercentage);
      /*Free gift 1 */

      if (freeShippingPercentage == 100) {
        $(".js__free-shipping__icon").addClass("active");
      }

      var shippingGrandRemaningAmount = shippingGrandTotal - totalAmount;
      var shippingGrandPercentage = 100;

      if (shippingGrandRemaningAmount > 0) {
        shippingGrandPercentage = totalAmount * 100 / shippingGrandTotal;
      }

      $(".js__free-shipping__progress-bar").children("span").css("width", shippingGrandPercentage + "%");
    });
  }
}
/*
ADDONS
NOTE:: CONFUSING CODE FOR THE ADDONS - WILL NEED TO CLEAN IT A BIT
1. Try to get all the addon handles for the items which are in the cart
2. Create an array for item>addon
3. Loop through all the cart items and addon
4. CHECK - if addon is already there in the list, then the same 2nd addon should not be visible
*/


function cartAddItemAddon(addonSelectedVariantID, addonQuantity) {
  CartJS.addItem(addonSelectedVariantID, addonQuantity, {}, {
    success: function success(data, textStatus, jqXHR) {
      console.log("success");
      /* Pending - Remove the selected addon when add to cart is clicked */
    },
    error: function error(jqXHR, textStatus, errorThrown) {
      console.log("error");
    }
  });
}

function addons() {
  //console.log("addons");

  /*Hide repeating addons*/
  var cartAddons = "";
  $(".js__top-cart-addons li").each(function (index) {
    // update this with variantID
    var addoneHandle = $(this).attr("data-handler"); // if cartAddon is null,

    if (cartAddons == "") {
      // save the addonHandle
      cartAddons = addoneHandle;
    } else {
      //set bool value to see if the addons is present in the addon list or not
      // by default it's false
      var boolCartAddons = false; // going through the string and checking if the current addon handle = the addon
      //handle present in the string

      var cartAddons2 = cartAddons.split(",");

      for (var a = 0; a < cartAddons2.length; a++) {
        if ($(this).attr("data-handler") == cartAddons2[a]) {
          // if present, then hide it
          $(this).hide();
          boolCartAddons = true;
        }
      } // add the new addon handle to the string


      if (boolCartAddons == false) {
        cartAddons = cartAddons + "," + addoneHandle;
      }
    }
    /* Hide the addons from the addon list, if the addon is present in the cart */


    var boolItemCartAddon = false;
    $(".js__ajax-products-bind li").each(function (index) {
      var itemHandle = $(this).attr("data-handle");

      if (addoneHandle == itemHandle) {
        boolItemCartAddon = true;
      }
    });

    if (boolItemCartAddon == true) {
      $(this).hide();
    } else {
      $(this).show();
    }
  });
  /* Hide the complete section if there are no addons */

  var boolAddonExist = false;
  $(".js__top-cart-addons li").each(function (index) {
    if ($(this).css("display") != "none") {
      boolAddonExist = true;
    }
  }); //console.log("boolAddonExist"+boolAddonExist);

  if (boolAddonExist == false) {
    //console.log("if");
    $(".js__freq-bought-products").hide();
  } else {
    //console.log("else");
    $(".js__freq-bought-products").show();
  }
} //Addons are fetched from the schemas; Varies from theme to theme


setTimeout(function () {
  addons();
}, 1000);
$(document).ready(function ($) {
  console.log("cart.js loaded");
  $(document).on("click", ".js__addon-add-to-cart", function () {
    var quantity = 1;
    var addonSelectedVariantID = $(this).attr("data-attr-variantid");
    console.log("cart.js click" + addonSelectedVariantID);
    cartAddItemAddon(addonSelectedVariantID, quantity);
  });
});
"use strict";

jQuery(function () {
  /* Hero Banner SLider */
  var heroSlider = new Swiper(".js__hero-banner-slider", {
    slidesPerView: 1,
    resistance: false,
    loop: false,
    // autoplay: {
    //     delay: 10000,
    // },
    // Navigation arrows
    pagination: {
      el: ".swiper-pagination-herobanner",
      clickable: true
    }
  });

  try {
    var pageTotal = parseInt($(".js__total-page").val());
    var currentPage = parseInt($(".js__current-page").val());
    var itemTotal = parseInt($(".js__items-count").val());
    var perPageItem = parseInt($(".js__perpage-item").val());
    var itemStart = 1;
    var itemEnd = 0;

    if (currentPage > 1) {
      itemStart = perPageItem * (currentPage - 1) + 1;
    }

    itemEnd = itemStart + perPageItem - 1;

    if (pageTotal == currentPage) {
      itemEnd = itemTotal;
    }

    $(".js__page-range").html(itemStart + " - " + itemEnd);
  } catch (_unused) {}
  /* PDP
    Tab working */


  $(".tab-link").on("click", function (event) {
    event.preventDefault(); // stop page from jumping

    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("tab-content");

    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none";
    }

    tablink = document.getElementsByClassName("tab-link");

    for (i = 0; i < tablink.length; i++) {
      tablink[i].className = tablink[i].className.replace(" active", "");
    }

    document.getElementById(dataId).style.display = "block";
    this.className += " active";
  });
  $(".js__pdp-tab-select").change(function () {
    $("#tab-link-" + $(this).val()).click();
  });
  $(document).on("click", ".pdp-tab-link", function (e) {
    var dataId = $(this).attr("data-attr");
    var i, tabcontent, tablink;
    tabcontent = document.getElementsByClassName("pdp-tab-content");
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").parent(".pdp-tab-small__wrapper__head").parent(".pdp-tab-small__wrapper__head-outer").parent(".pdp-tab-small__wrapper").children(".pdp-tab-small__wrapper__content").children(".pdp-tab-content").hide();
    $(this).parent("li").parent("ul").children("li").children(".pdp-tab-link").removeClass("active");
    tablink = document.getElementsByClassName("pdp-tab-link");
    document.getElementById(dataId).style.display = "block";
    event.currentTarget.className += " active";
    $(this).addClass("active");
    /*PDP select*/

    $(".js__pdp-tab-select").val(dataId);
  });
  /* GLOBAL
    Scroll to particular Div with # value */

  $('a[href^="#"]').on("click", function (event) {
    var target = $(this.getAttribute("href"));

    if (target.length) {
      event.preventDefault();
      $("html, body").stop().animate({
        scrollTop: target.offset().top - 150
      }, 1000);
    }
  });
  /* accordion working about content in small screen*/

  $(".js__accordian").children("li").children("h2,h4,h5,h3,.feature-header").click(function (e) {
    if ($(this).parent("li").children(".content").css("display") == "none") {
      $(this).parent("li").parent(".js__accordian").children("li").children(".content").hide();
      $(this).parent("li").parent(".js__accordian").children("li").removeClass("active");
      $(this).parent("li").children(".content").slideDown();
      $(this).parent("li").addClass("active");
    } else {
      $(this).parent("li").children(".content").slideUp();
      $(this).parent("li").removeClass("active");
    }
  });
  /* Accordion working when we have multiple content*/

  $(".js__accordians").children("li").attr("aria-expanded", false);
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("role", "button");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").attr("tabindex", "0");
  $(".js__accordians").children("li").children("h5,h6,h3,h4").click(function (e) {
    var type = $(this).parent("li").attr("data-attr");

    if ($("." + type).css("display") == "none") {
      $(this).attr("aria-expanded", true);
      $(this).parent("li").parent(".js__accordians").children(".content").hide();
      $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
      $("." + type).slideDown();
      $(this).parent("li").addClass("active");
      $(this).addClass("active");
    } else {
      $(this).attr("aria-expanded", false);
      $(this).parent("li").removeClass("active");
      $("." + type).slideUp();
      $(this).removeClass("active");
    }
  });
  $(".js__accordians").children("li").children("h5,h6,h3,h4").keypress(function (e) {
    if (e.which == 13) {
      var type = $(this).parent("li").attr("data-attr");

      if ($("." + type).css("display") == "none") {
        $(this).attr("aria-expanded", true);
        $(this).parent("li").parent(".js__accordians").children(".content").hide();
        $(this).parent("li").parent(".js__accordians").children("li").removeClass("active");
        $("." + type).slideDown();
        $(this).parent("li").addClass("active");
        $(this).addClass("active");
      } else {
        $(this).attr("aria-expanded", false);
        $(this).parent("li").removeClass("active");
        $("." + type).slideUp();
        $(this).removeClass("active");
      }
    }
  });
});
/* Mini cart - Checkout Button visiblity fix for IOS Mobile */

var lastScroll = 0;
jQuery(document).ready(function ($) {
  $(".cart-sidebar__middle").addClass("safari-mobile");
  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll > lastScroll) {
      $(".cart-sidebar__middle").removeClass("safari-mobile");
    } else if (scroll < lastScroll) {
      $(".cart-sidebar__middle").addClass("safari-mobile");
    }

    lastScroll = scroll;
  });
});
jQuery(function ($) {
  $(".js__modal-close").on("click", function () {
    $(".modal").hide();
  });
  $(document).keydown(function (event) {
    if (event.keyCode == 27) {
      $(".modal").hide();
    }
  });
});
/*First tab link and first tab content active */

jQuery(document).ready(function ($) {
  $(".tab-link").first().addClass("active");
  $(".pdp-tab-link").first().addClass("active");
  $(".shopify-section .tab-content").first().show();
  $(".pdp-tab-section .tab-content").first().show();
  $(".pdp-tab-small .tab-content").first().show();
  $(".pdp-tab-content").first().show();
  $(document).on("click", ".js__tab-small", function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".accordion-link").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active"); // $(this).parent(".tab-content").addClass("active");

      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $("html,body").animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      // $(".accordion-con").slideUp();
      // $(".accordion-con").removeClass("active");
      // $(".tab-content").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-link").removeClass("active"); // $(this).parent(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
  $(document).on("click", ".js___accordion", function (e) {
    e.preventDefault();

    if ($(this).parent(".tab-content").children(".accordion-con").css("display") == "none") {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active");
      $(".accordion-link").removeClass("active"); // $(".tab-content").removeClass("active");

      $(".tab-link").removeClass("active");
      $(this).parent(".tab-content").children(".accordion-con").slideDown();
      $(this).parent(".tab-content").children(".accordion-con").addClass("active"); // $(this).parent(".tab-content").addClass("active");

      $(this).parent(".tab-content").children(".accordion-link").addClass("active");
      var dataId = $(this).parent(".tab-content").attr("data-attr");
      document.getElementById(dataId).className += " active";
      $("html,body").animate({
        scrollTop: $(this).offset().top - 120
      }, 500);
    } else {
      $(".accordion-con").slideUp();
      $(".accordion-con").removeClass("active"); // $(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-link").removeClass("active"); // $(this).parent(".tab-content").removeClass("active");

      $(this).parent(".tab-content").children(".accordion-con").removeClass("active");
    }
  });
});
/*Select Dropdown change wit Tab */

jQuery(function () {
  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path

  $(".dropdown-select option").each(function () {
    if (this.value.toLowerCase() == path.toLowerCase()) {
      this.setAttribute("selected", true);
    }
  });
  $(".dropdown-select").change(function () {
    var dropdown = $(".dropdown-select").val();
    $(".js__faq-search-section").addClass("hide");
    $(".js__faq-tab").removeClass("hide");
    $("#txt-faq-search").val("");
    $(".js__no-data-found").addClass("hide"); //first hide all tabs again when a new option is selected

    $(".tab-content").hide(); //then show the tab content of whatever option value was selected

    $("#" + "tab-" + dropdown).show();

    if (dropdown == "all") {
      $(".js__tab-content").each(function () {
        if ($(this).find(".js__accordian").html().trim() == "<li>Sorry Data Is Not Added Yet</li>") {
          $(this).hide();
        } else {
          $(this).show();
        }
      });
    }
  });
  $(".js__tab-content").each(function () {
    if ($(this).find(".js__accordian").html().trim() == "") {
      $(this).find(".js__accordian").html("<li>Sorry Data Is Not Added Yet</li>");
    }
  });
});
/*Blog content checking if p tag has image then adding class*/

jQuery(function ($) {
  $(".article-content p").each(function () {
    var $p = $(this); // Check if paragraph has img or iframe

    if ($p.find("img, iframe").length) {
      $p.addClass("full-width"); // Wrap text nodes

      $p.contents().each(function () {
        if (this.nodeType === 3 && this.nodeValue.trim().length > 0) {
          $(this).replaceWith('<span class="text-content">' + this.nodeValue + "</span>");
        }
      });
    } else {
      // Wrap text-only paragraphs
      if (!$p.find("span.text-content").length) {
        $p.contents().filter(function () {
          return this.nodeType === 3 && this.nodeValue.trim().length > 0;
        }).wrap('<span class="text-content"></span>');
      }
    } // 👇 check for video after everything


    if ($p.find(".video-wrapper").length) {
      $p.addClass("has-video");
    }
  });
}); // jQuery(document).ready(function ($) {
//     // Get the element
//     for (var i = 0; i < 250; i++) {
//       var marqueeFooter = document.querySelector('.js__marquee-right .repeat');
//       // Create a copy of it
//       var cloneFooter = marqueeFooter.cloneNode(true);
//       // Inject it into the DOM
//       marqueeFooter.before(cloneFooter);
//     }
//   });

jQuery(document).ready(function ($) {
  $(".hero-banner-slider .content").addClass("animate");
});
jQuery(document).ready(function ($) {
  $(document).on("click", ".js__card-add-to-cart", function (e) {
    console.log("add to cart clicked");
    var selectedVariantID = $(this).attr("data-variant-id");
    var quantity = 1;
    var items = [];
    /* For the main item */

    items.push({
      id: selectedVariantID,
      quantity: quantity
    });
    CartJS.addItems(items, {
      success: function success(response, textStatus, jqXHR) {
        console.log("success adding to cart");
        $(".modal-quick-view").hide();
        $(".js__card-add-to-cart-" + selectedVariantID).addClass("added");
        $(".js__card-add-to-cart-" + selectedVariantID).html("Added");

        if (getglobalLib("Mini_Cart") == "yes") {
          /* Show message */
          setTimeout(openMiniCart, 500);
        } else {
          window.location = "/cart";
        }
      },
      // Define an error callback to display an error message.
      error: function error(jqXHR, textStatus, errorThrown) {
        showCartErrorMessage();
        console.log("error adding to cart");
      }
    });
  });
}); // Footer DropDown Of Link

jQuery(document).ready(function ($) {
  var initFooterAccordionState = function initFooterAccordionState() {
    if ($(window).width() <= 981) {
      // Mobile / tablet: start with all closed
      $(".footer-links .accordion-content").hide().removeClass("active");
      $(".footer-links .accordion-toggle").removeClass("active");
    } else {
      // Desktop: show all links, no accordion behavior
      $(".footer-links .accordion-content").show().removeClass("active");
      $(".footer-links .accordion-toggle").removeClass("active");
    }
  }; // Initial state on page load


  initFooterAccordionState();
  $(".footer-links .accordion-toggle").on("click", function (e) {
    if ($(window).width() <= 981) {
      e.preventDefault();
      e.stopPropagation();
      var $toggle = $(this);
      var $content = $toggle.next(".accordion-content");

      if ($toggle.hasClass("active")) {
        // 🔽 Already open → close it
        $toggle.removeClass("active");
        $content.slideUp(300);
      } else {
        // 🔼 Open this one and close others
        $(".footer-links .accordion-toggle").removeClass("active");
        $(".footer-links .accordion-content").slideUp(300).removeClass("active");
        $toggle.addClass("active");
        $content.slideDown(300).addClass("active");
      }
    }
  }); // Reset state when resizing between desktop and mobile

  $(window).on("resize", function () {
    initFooterAccordionState();
  });
});
"use strict";

var showCartMessage = true;
jQuery(function () {
  //Nav - Open and Close Mini cart
  if (getglobalLib("Mini_Cart") == "yes") {
    $(".js__cart-expand").on("click", function () {
      // Toggle cart sidebar visibility
      $("#CartSidebar").toggleClass("active");
      $("#cart_overlay").toggleClass("active"); // Manage active state on trigger

      $(this).addClass("active"); // Lock/unlock body scroll based on sidebar visibility

      if ($("#CartSidebar").hasClass("active")) {
        $("html").addClass("fixed");
      } else {
        $("html").removeClass("fixed");
        $(".js__cart-expand").removeClass("active");
      }
    });
    $("#js__cart-close").on("click", function () {
      $("#CartSidebar").removeClass("active");
      $("#cart_overlay").removeClass("active");
      $(".js__cart-expand").removeClass("active");
      $("html").removeClass("fixed");
    }); // Close cart on ESC key press

    $(document).on("keydown", function (e) {
      if (e.key === "Escape" || e.keyCode === 27) {
        $("#CartSidebar").removeClass("active");
        $("#cart_overlay").removeClass("active");
        $(".js__cart-expand").removeClass("active");
        $("html").removeClass("fixed");
      }
    });
    $(".js__cart-expand").attr("href", "javascript:;");
  }
  /* Cart - Free Shipping Progress bar Visiblity */


  try {
    if (getglobalLib("Free_Shipping_progressbar") == "yes" && $(".js__free-shipping-limit").html().trim() != "" && showProgressBar == true) {
      $(".js__progressbar_visiblity").removeClass("hide");
    }
  } catch (_unused) {}
  /* Remove mini cart from the cart page */


  if ($(".cart-table-body")[0]) {
    $("#CartSidebar").remove();
    $("#cart_overlay").remove();
    $(".js__top-cart-form-actions").remove();
    $(".js__ajax-products-bind").remove();
    $(".mini-cart").removeClass("js__cart-expand");
    $(".mini-cart").attr("href", "/cart");
  }
  /* show no items in cart */


  if (CartJS.cart.item_count == 0) {
    $(".empty-cart-section").show();
    $(".js__show-cart-items-section").hide();
    $("#shopify-section-cart-recommendations").hide();
  } else {
    $(".empty-cart-section").hide();
  }
  /*Quantity Plus Minus for the textbox */


  $(".js__product-single__quantity .js__minus-qty").click(function () {
    decreaseQuantity();
  });
  $(".js__product-single__quantity .js__plus-qty").click(function () {
    increaseQuantity();
  });

  function increaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();
    productQuantity++;
    $(".js__quantity-selector").val(productQuantity);
  }

  function decreaseQuantity() {
    var productQuantity = $(".js__quantity-selector").val();

    if (productQuantity > 1) {
      productQuantity--;
    }

    $(".js__quantity-selector").val(productQuantity);
  }
});
/* 
NOTIFICATIONS SECTION
Show Noticiations On Success and Error
Note: This function isn't being used in every theme
Feel free to comment/uncomment as per the functionality
*/

function showCartSuccessMessage() {
  setTimeout(openMiniCart, 500);

  if (showCartMessage == true) {
    $("#cart-message").addClass("message-success");
    $("#cart-message").removeClass("message-error");
    $("#cart-message").html("Successfully added to cart!");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function showCartErrorMessage() {
  if (showCartMessage == true) {
    $("#cart-message").removeClass("message-success");
    $("#cart-message").addClass("message-error");
    $("#cart-message").html("Sorry! Seems like the product is out of stock");
    $("#cart-message").show();
    setTimeout(function () {
      $("#cart-message").hide();
    }, 5000);
  }
}

function openMiniCart() {
  fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (res) {
    return res.json();
  }).then(function (data) {
    // Always open cart sidebar (do not toggle) and lock body scroll
    $("#CartSidebar").addClass("active");
    $("#cart_overlay").addClass("active");
    $("html").addClass("fixed");
  });
}
/* EVENT: When the cart request is completed everytime the below function is run */


$(document).on("cart.requestComplete", function (event, cart) {
  reloadAjaxCartItemUsingCartAjaxObject(cart); //Progress Bar of shipping in cart and mini cart; Varies from theme to theme

  progressBar(); //Show and hide empty cart depending upon the cart items

  setTimeout(function () {
    // calculateSubTotalWithDiscount();
    addons();
  }, 1000);
}); // $(document).on("cart.requestStarted", function (event, cart) {console.log("Request started"); });
//$(document).on("cart.ready", function (event, cart) {});

/* currency formatter */

var formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
"use strict";

jQuery(function () {
  /* Footer - Accordion Visiblity */
  if (getglobalLib("Footer_Accordion") == "yes") {
    $(".js__accordion-toggle-visiblity").addClass("accordion-toggle-footer");
    $(".js__accordion-content-visiblity").addClass("accordion-content-footer");
  }
  /* FAQ - Category Sidebar Visiblity */


  if (getglobalLib("FAQ_Side_Panel") == "yes") {
    $(".js__faq-category-side-panel").removeClass("hide");
  }

  if (getglobalLib("Product_Recommendation_Slider") == "on") {
    $("#js__pdp-recommendation-slider").not(".slick-initialized").slick({
      slidesToShow: 4,
      slidesToScroll: 4,
      dots: false,
      centerMode: false,
      infinite: false,
      focusOnSelect: true,
      variableWidth: true,
      draggable: true
    });
  }
});
"use strict";

document.addEventListener("DOMContentLoaded", function () {
  if (window.Swiper) {
    new Swiper(".js__announcement-slider", {
      slidesPerView: 1,
      resistance: false,
      shortSwipes: true,
      loop: true,
      autoplay: {
        delay: 6000
      }
    });
  } else {
    console.warn("Swiper is not loaded!");
  } //Close Announcement Bar on Click


  document.getElementById("announcement-close").addEventListener("click", function () {
    document.querySelector(".announcement-bar").style.display = "none";
    document.body.classList.remove("announcement-visible");
    document.body.classList.add("announcement-hide");
  });
});
document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("mainHeader");
  var body = document.body;
  var subItems = document.querySelectorAll(".has-sub-nav");
  var bigItems = document.querySelectorAll(".has-big-nav");
  var searchBtn = document.getElementById("js__header-search-btn");
  var searchSection = document.getElementById("js-header-search-section");

  var isSearchOpen = function isSearchOpen() {
    return searchBtn && searchBtn.dataset.open === "true" || searchSection && searchSection.classList.contains("visible");
  };

  var forceCloseSearch = function forceCloseSearch() {
    if (!isSearchOpen()) return;
    searchSection === null || searchSection === void 0 ? void 0 : searchSection.classList.remove("visible");
    searchBtn === null || searchBtn === void 0 ? void 0 : searchBtn.classList.remove("active");
    if (searchBtn) searchBtn.dataset.open = "false";
  };

  function closeAllSubMenus() {
    document.querySelectorAll(".sub-nav.active").forEach(function (sub) {
      sub.style.visibility = "hidden";
      sub.style.opacity = "0";
      sub.classList.remove("active");
    });
    document.querySelectorAll(".has-sub-nav .site-nav__link").forEach(function (lnk) {
      return lnk.classList.remove("hover-submenu");
    });
  }

  function closeAllBigMenus() {
    document.querySelectorAll(".big-nav.active").forEach(function (big) {
      big.style.visibility = "hidden";
      big.style.opacity = "0";
      big.classList.remove("active");
    });
    document.querySelectorAll(".has-big-nav .site-nav__link").forEach(function (lnk) {
      return lnk.classList.remove("hover-submenu");
    });
  }

  function openSubMenu(item) {
    // Ensure search is closed before opening any submenu
    forceCloseSearch();
    var link = item.querySelector(".site-nav__link");
    var subNav = item.querySelector(".sub-nav");
    closeAllSubMenus(); // CLOSE all sub menus first

    closeAllBigMenus();
    if (link) link.classList.add("hover-submenu");

    if (subNav) {
      subNav.style.visibility = "visible";
      subNav.style.opacity = "1";
      subNav.classList.add("active");
    }

    header.classList.remove("transparent");
    header.classList.add("white");
    body.classList.add("white-header");
  }

  function openBigMenu(item) {
    // Ensure search is closed before opening any big menu
    forceCloseSearch();
    var link = item.querySelector(".site-nav__link");
    var bigNav = item.querySelector(".big-nav");
    closeAllBigMenus(); // CLOSE all big menus first

    closeAllSubMenus(); // CLOSE sub menu

    if (link) link.classList.add("hover-submenu");

    if (bigNav) {
      bigNav.style.visibility = "visible";
      bigNav.style.opacity = "1";
      bigNav.classList.add("active");
    }

    header.classList.remove("transparent");
    header.classList.add("white");
    body.classList.add("white-header");
  } // ---- Sub menu hover (DESKTOP ONLY) ----


  subItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      // Only run on desktop
      if (window.innerWidth >= 981) {
        openSubMenu(item);
      }
    }); // item.addEventListener("mouseleave", () => closeAllSubMenus());
  }); // ---- Big menu hover (DESKTOP ONLY) ----

  bigItems.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (window.innerWidth >= 981) {
        openBigMenu(item);
      }
    }); // item.addEventListener("mouseleave", () => closeAllBigMenus());
  }); // ---- CLOSE EVERYTHING on outside hover ----

  document.addEventListener("mousemove", function (e) {
    var searchOpen = isSearchOpen(); // Keep header white while search is open

    if (searchOpen) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    var outsideMenus = !e.target.closest(".has-sub-nav") && !e.target.closest(".has-big-nav");

    if (outsideMenus) {
      // Always close menus, even when header is fixed (sticky)
      closeAllSubMenus();
      closeAllBigMenus(); // Only revert to transparent when header is not fixed

      if (!header.classList.contains("fixed")) {
        header.classList.remove("white");
        body.classList.remove("white-header");
        header.classList.add("transparent");
      }
    }
  });
}); // Search

document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("mainHeader");
  var body = document.body;
  var searchSection = document.getElementById("js-header-search-section");
  var searchBtn = document.getElementById("js__header-search-btn");
  var bigNav = document.querySelector(".big-nav");
  var bigNavTriggers = document.querySelectorAll(".has-big-nav");
  var subNavTriggers = document.querySelectorAll(".has-sub-nav");
  if (!searchSection || !searchBtn) return;
  var searchInput = searchSection.querySelector(".search"); // 🔹 CLOSE ALL MENUS

  function closeAllMenus() {
    if (bigNav !== null && bigNav !== void 0 && bigNav.classList.contains("active")) {
      bigNav.classList.remove("active");
      bigNav.style.visibility = "hidden";
      bigNav.style.opacity = "0";
    }

    document.querySelectorAll(".sub-nav.active").forEach(function (sub) {
      sub.style.visibility = "hidden";
      sub.style.opacity = "0";
      sub.classList.remove("active");
    });
    subNavTriggers.forEach(function (item) {
      item.classList.remove("hover-submenu");
    });
  } // 🔹 APPLY HEADER WHITE


  function applyHeaderWhite() {
    header.classList.add("white");
    header.classList.remove("transparent");
    body.classList.add("white-header");
  } // 🔹 REMOVE HEADER WHITE (BUT RESPECT FIXED RULE)


  function removeHeaderWhite() {
    body.classList.remove("white-header"); // IF FIXED → do NOT add transparent, KEEP white

    if (header.classList.contains("fixed")) {
      header.classList.add("white");
      header.classList.remove("transparent");
      return;
    } // Otherwise allow transparent header


    header.classList.remove("white");
    header.classList.add("transparent");
  } // 🔸 OPEN SEARCH


  function openSearch() {
    closeAllMenus();
    searchSection.classList.add("visible");
    searchBtn.classList.add("active");
    searchBtn.dataset.open = "true";
    applyHeaderWhite();
    searchInput === null || searchInput === void 0 ? void 0 : searchInput.focus();
  }

  function closeSearch() {
    searchSection.classList.remove("visible");
    searchBtn.classList.remove("active");
    searchBtn.dataset.open = "false";
    var submenuActive = document.querySelector(".has-sub-nav .hover-submenu") || document.querySelector(".sub-nav.active");
    var bigNavActive = document.querySelector(".has-big-nav .hover-submenu") || document.querySelector(".big-nav.active"); // Keep header white if a menu is being hovered/opened

    if (submenuActive || bigNavActive) {
      header.classList.add("white");
      header.classList.remove("transparent");
      body.classList.add("white-header");
      return;
    }

    removeHeaderWhite();
  } // Toggle by click


  searchBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    e.preventDefault();
    searchBtn.dataset.open === "true" ? closeSearch() : openSearch();
  }); // Close when clicking outside

  document.addEventListener("click", function () {
    if (searchBtn.dataset.open === "true") closeSearch();
  }); // Prevent search from closing when clicking inside

  searchSection.addEventListener("click", function (e) {
    return e.stopPropagation();
  }); // ESC close

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && searchBtn.dataset.open === "true") closeSearch();
  }); // Hovering any submenu auto closes search

  subNavTriggers.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (searchBtn.dataset.open === "true") closeSearch();
    });
  }); // Hovering any big menu auto closes search

  bigNavTriggers.forEach(function (item) {
    item.addEventListener("mouseenter", function () {
      if (searchBtn.dataset.open === "true") closeSearch();
    });
  });
}); // Open MObile Menu

document.addEventListener("DOMContentLoaded", function () {
  var navLink = false;
  var hamburger = document.getElementById("hamburger");
  var nav = document.getElementById("navbarNavDropdown");
  var header = document.getElementById("mainHeader");
  var hideEls = document.querySelectorAll(".js__mobile-menu-open-hide, .js__mobile-announcement-text"); // 🔍 Check if page has hero/inner-banner/error-page

  var hasHero = !!document.querySelector(".hero-banner, .inner-hero-section, .error-page, .collection-hero-section"); // 🧠 Handles header state on scroll & nav open/close

  var updateHeaderState = function updateHeaderState() {
    var scrollY = window.scrollY; // 🧩 Pages without hero → always white, always white-header

    if (!hasHero) {
      header.classList.add("white");
      header.classList.remove("transparent");
      document.body.classList.add("white-header");
      return;
    } // 🧩 Pages with hero → normal behavior


    if (nav.classList.contains("active")) {
      // 🔹 When mobile menu is open
      header.classList.remove("transparent");
      header.classList.add("white");
      document.body.classList.add("white-header");
    } else {
      // 🔹 When menu is closed
      document.body.classList.remove("white-header");

      if (scrollY > 33) {
        header.classList.add("fixed", "white");
        header.classList.remove("transparent");
      } else {
        header.classList.remove("fixed", "white");
        header.classList.add("transparent");
      }
    }
  }; // 🍔 Toggles mobile menu


  var toggleMenu = function toggleMenu() {
    hamburger.classList.toggle("active");
    nav.classList.toggle("active");
    navLink = true;
    hideEls.forEach(function (el) {
      return nav.classList.contains("active") ? el.classList.add("active") : el.classList.remove("active");
    }); // Lock scroll when open (for mobile)

    if (nav.classList.contains("active")) {
      if (window.innerWidth < 981) {
        // Prevent body/page scroll but allow menu container to scroll
        document.documentElement.style.overflow = "hidden"; // document.body.style.overflow = "hidden";

        document.documentElement.classList.add("scroll-stop"); // Ensure menu container can scroll

        if (nav) {
          nav.style.overflowY = "auto";
          nav.style.WebkitOverflowScrolling = "touch";
          nav.style.touchAction = "pan-y";
        }
      } else {
        document.documentElement.style.overflowY = "scroll"; // document.body.style.overflow = "";

        document.documentElement.classList.remove("scroll-stop");

        if (nav) {
          nav.style.overflowY = "";
        }
      }
    } else {
      document.documentElement.style.overflowY = "scroll";
      document.body.style.overflow = "";
      document.documentElement.classList.remove("scroll-stop");

      if (nav) {
        nav.style.overflowY = "";
      }
    }

    updateHeaderState();
  };

  hamburger.addEventListener("click", toggleMenu);
  hamburger.addEventListener("focus", function () {
    if (!navLink) toggleMenu();
  });
  window.addEventListener("resize", updateHeaderState);
  window.addEventListener("scroll", updateHeaderState);
  updateHeaderState();
}); // Dynamic Mobile Nav Bar top according to the height of the header and the announcement

document.addEventListener("DOMContentLoaded", function () {
  var nav = document.getElementById("navbarNavDropdown");
  var header = document.getElementById("mainHeader");
  var announcement = document.querySelector(".announcement-bar");
  var announcementClose = document.getElementById("announcement-close");

  function isVisible(el) {
    return el && el.offsetParent !== null && el.offsetHeight > 0;
  }

  function setNavTop() {
    if (!nav || !header) return; // Desktop: let CSS handle positioning

    if (window.innerWidth >= 981) {
      nav.style.top = "";
      return;
    } // Mobile: header height + (announcement height if visible)


    var headerRect = header.getBoundingClientRect();
    var headerHeight = headerRect && headerRect.height ? headerRect.height : 0;
    var totalHeight = headerHeight;

    if (isVisible(announcement)) {
      totalHeight += announcement.offsetHeight;
    }

    nav.style.top = "".concat(totalHeight, "px");
  } // Run on load


  setNavTop(); // Run on resize & scroll (header may change height when fixed)

  window.addEventListener("resize", setNavTop);
  window.addEventListener("scroll", setNavTop, {
    passive: true
  }); // Recalculate when announcement is closed

  if (announcementClose) {
    announcementClose.addEventListener("click", function () {
      setTimeout(setNavTop, 80);
    });
  }
});
/** CART SIDEBAR
 * Close on Outside Click
 * **/

$(document).mouseup(function (e) {
  var popup = $("#CartSidebar");
  var overlay = $("#cart_overlay");

  if (!popup.is(e.target) && popup.has(e.target).length == 0) {
    popup.removeClass("active");
    overlay.removeClass("active");
    $("html").removeClass("fixed");
    $(".js__cart-expand").removeClass("active");
  }
});
/* OPEN BIG NAV SECTION ON mobile (simplified, reliable behaviour) */

(function ($) {
  $(function () {
    var navLink = false; // Guard timestamp for preventing ghost taps after closing a big-nav

    if (typeof window.bigNavTapBlockedUntil === "undefined") {
      window.bigNavTapBlockedUntil = 0;
    } // MOBILE ONLY: delegate like sub-nav


    $(document).on("click", ".js__big-nav-link", function (e) {
      // Mobile only
      if ($(window).width() >= 981) {
        return;
      } // If we just closed a big-nav very recently, ignore this tap


      if (Date.now() < window.bigNavTapBlockedUntil) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      } // If sub-nav is in the middle of closing, block this tap


      if (window.isClosingSubNav) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      } // Store references to the clicked element


      var $clickedLink = $(this);
      var $parentLi = $clickedLink.closest("li.has-big-nav");
      var $bigNav = $parentLi.find(".js__big-nav"); // Validate that we found the elements

      if (!$bigNav.length || !$parentLi.length) {
        console.warn("Big nav elements not found for:", $clickedLink);
        return;
      } // Get unique identifier for this menu (for debugging)


      var clickedMenuText = $clickedLink.text().trim();
      console.log("Big-nav clicked:", clickedMenuText, "Current state:", $bigNav.hasClass("active")); // Check if THIS specific big-nav is already open

      var isCurrentlyOpen = $bigNav.hasClass("active") && $clickedLink.hasClass("active");

      if (isCurrentlyOpen) {
        // Close this one
        console.log("Closing:", clickedMenuText);
        $clickedLink.removeClass("active");
        $bigNav.removeClass("active");
        $parentLi.removeClass("big-nav-open");
      } else {
        // FIRST: Close ALL big-navs completely (force close everything)
        var allBigNavs = $(".js__big-nav");
        var allBigNavLinks = $(".js__big-nav-link");
        var allBigNavLis = $("li.has-big-nav");
        console.log("Closing all big-navs. Count:", allBigNavs.length);
        allBigNavs.removeClass("active");
        allBigNavLinks.removeClass("active");
        allBigNavLis.removeClass("big-nav-open"); // THEN: Open ONLY the clicked one (using stored references)

        console.log("Opening:", clickedMenuText);
        $clickedLink.addClass("active");
        $bigNav.addClass("active");
        $parentLi.addClass("big-nav-open"); // Mark when this big-nav was opened and when link was clicked

        $bigNav.data("opened-time", Date.now());
        $clickedLink.data("click-time", Date.now()); // Verify only one is open

        var openCount = $(".js__big-nav.active").length;

        if (openCount > 1) {
          console.error("ERROR: Multiple big-navs are open! Count:", openCount);
        }
      }

      navLink = true; // Set global flag to prevent accordion from opening

      window.menuLinkClicked = true;
      setTimeout(function () {
        window.menuLinkClicked = false;
      }, 200);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
    }).on("focus", ".js__big-nav-link", function () {
      "use strict";

      if (!navLink && $(window).width() < 981) {
        var $parentLi = $(this).closest("li");
        var $bigNav = $parentLi.find(".js__big-nav");
        $(this).addClass("active");
        $bigNav.addClass("active");
        $parentLi.addClass("big-nav-open");
      }
    });
  });
})(jQuery);
/* OPEN SUB NAV SECTION ON MOBILE */


(function ($) {
  $(function () {
    var navLink = false;
    var isClosingSubNav = false; // Flag to prevent link click when closing sub-nav
    // Use event delegation to ensure handler works - MOBILE ONLY

    $(document).on("click", ".js__sub-nav-link", function (e) {
      // Only run on mobile devices
      if ($(window).width() >= 981) {
        return; // Don't run on desktop
      } // Only prevent if we're in the middle of closing (ghost click prevention)


      if (window.isClosingSubNav) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      } // Only block if click is specifically on the back button


      var $target = $(e.target);

      if ($target.closest(".js__sub-nav-close").length > 0) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      var $parentLi = $(this).closest("li");
      var $subNav = $parentLi.find(".js__sub-nav");
      var $link = $(this); // If this sub-nav is already open, just close it (toggle behavior)

      if ($subNav.hasClass("active")) {
        $link.removeClass("active");
        $subNav.removeClass("active");
        $parentLi.removeClass("sub-nav-open");
      } else {
        isClosingSubNav = false; // Close any other open sub-navs first

        $(".js__sub-nav").removeClass("active");
        $(".js__sub-nav-link").removeClass("active");
        $("li.sub-nav-open").removeClass("sub-nav-open"); // Add active class to link and open sub-nav

        $link.addClass("active");
        $subNav.addClass("active");
        $parentLi.addClass("sub-nav-open"); // Mark when this sub-nav was opened and when link was clicked

        $subNav.data("opened-time", Date.now());
        $link.data("click-time", Date.now());
      }

      navLink = true; // Set global flag to prevent accordion from opening

      window.menuLinkClicked = true;
      setTimeout(function () {
        window.menuLinkClicked = false;
      }, 1000);
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // Prevent accordion handler from firing
    }); // Focus handler

    $(document).on("focus", ".js__sub-nav-link", function (e) {
      "use strict";

      if (navLink) {} else {
        var $parentLi = $(this).closest("li");
        var $subNav = $parentLi.find(".js__sub-nav");
        $(this).toggleClass("active");
        $subNav.toggleClass("active");
        $parentLi.toggleClass("sub-nav-open");
      }
    }); // Store reference to link handler for use in close handler

    window.subNavLinkHandler = {
      setClosingFlag: function setClosingFlag() {
        isClosingSubNav = true;
        console.log("Closing flag set"); // Reset flag after a short delay to allow click event to complete

        setTimeout(function () {
          isClosingSubNav = false;
          console.log("Closing flag reset");
        }, 100); // Reduced delay
      },
      resetFlag: function resetFlag() {
        isClosingSubNav = false;
        console.log("Closing flag manually reset");
      }
    };
  });
})(jQuery); // Close MOBILE Sub NAV ON CLICK BACK


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__sub-nav-close").on("mousedown", function (e) {
      e.stopPropagation(); // Prevent event bubbling to parent elements

      e.preventDefault(); // Prevent default behavior

      e.stopImmediatePropagation(); // Stop all other handlers on this element

      window.isClosingSubNav = true;

      if (window.subNavLinkHandler && window.subNavLinkHandler.setClosingFlag) {
        window.subNavLinkHandler.setClosingFlag();
      }

      var $subNav = $(this).closest(".js__sub-nav");
      var $parentLi = $(this).closest("li");
      var $navLink = $parentLi.find(".js__sub-nav-link"); // IMPORTANT: Add a temporary overlay to block clicks during closing

      var $overlay = $('<div class="sub-nav-close-overlay" style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; z-index: 9998; pointer-events: all; background: transparent;"></div>');
      $("body").append($overlay); // Close the sub-nav with a slight delay to ensure overlay is in place

      setTimeout(function () {
        $subNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("sub-nav-open"); // Remove overlay after a delay

        setTimeout(function () {
          $overlay.remove();
          window.isClosingSubNav = false;

          if (window.subNavLinkHandler && window.subNavLinkHandler.resetFlag) {
            window.subNavLinkHandler.resetFlag();
          }
        }, 300);
      }, 10);
      navLink = true; // Prevent click from reaching elements below by blocking the event completely

      return false;
    }).on("click", function (e) {
      console.log("Sub-nav-close click fired"); // Also prevent click event (in addition to mousedown)

      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
      window.isClosingSubNav = true;
      setTimeout(function () {
        window.isClosingSubNav = false;
      }, 200);
      return false;
    }).on("mouseup", function (e) {
      // Also prevent mouseup to be extra safe
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        var $subNav = $(this).closest(".js__sub-nav");
        var $parentLi = $(this).closest("li");
        var $navLink = $parentLi.find(".js__sub-nav-link");
        $subNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("sub-nav-open");
      }
    });
  });
})(jQuery); // Open Search in mobile


(function ($) {
  $(document).ready(function () {
    var navLink = false; // Open Mobile Search

    $("#js__mobile-search").on("mousedown", function () {
      $(this).toggleClass("active");
      $("#js-header-search-block").toggleClass("active");
      navLink = true;
    }).on("focus", function () {
      if (!navLink) {
        $(this).toggleClass("active");
        $("#js-header-search-block").toggleClass("active");
      }
    }); // Close Mobile Search

    $(".js__search-mobile-close").on("mousedown", function () {
      $(this).toggleClass("active");
      $("#js-header-search-block").toggleClass("active");
      $("#js__mobile-search").toggleClass("active");
      navLink = true;
    }).on("focus", function () {
      if (!navLink) {
        $(this).toggleClass("active");
        $("#js-header-search-block").toggleClass("active");
        $("#js__mobile-search").toggleClass("active");
      }
    });
  });
})(jQuery); // Close Big SUB NAV ON CLICK BACK


(function ($) {
  $(function () {
    var navLink = false;
    $(".js__big-nav-close").on("click", function (e) {
      // Block event from reaching elements below
      e.stopPropagation();
      e.preventDefault();
      e.stopImmediatePropagation(); // Find the specific big-nav related to this close button

      var $bigNav = $(this).closest(".js__big-nav");
      var $parentLi = $(this).closest("li");
      var $navLink = $parentLi.find(".js__big-nav-link"); // Close the big-nav immediately and briefly block new big-nav taps

      $bigNav.removeClass("active");
      $navLink.removeClass("active");
      $parentLi.removeClass("big-nav-open"); // Remove class from parent
      // re-triggering the header link underneath (e.g. COMBOS). Use a slightly
      // longer window for slower mobile devices.

      window.bigNavTapBlockedUntil = Date.now() + 800;
      navLink = true;
      return false;
    }).focus(function (e) {
      "use strict";

      if (navLink) {} else {
        var $bigNav = $(this).closest(".js__big-nav");
        var $parentLi = $(this).closest("li");
        var $navLink = $parentLi.find(".js__big-nav-link");
        $bigNav.removeClass("active");
        $navLink.removeClass("active");
        $parentLi.removeClass("big-nav-open");
      }
    });
  });
})(jQuery); // Mobile Sub menu Menu Accordion


(function ($) {
  $(function () {
    var navLink = false; // Global flag to track menu link clicks

    if (typeof window.menuLinkClicked === "undefined") {
      window.menuLinkClicked = false;
    }

    $(".accordion-toggle-inner").on("click", function (e) {
      "use strict"; // EARLY EXIT: If a menu link was just clicked, don't open accordion

      if (window.menuLinkClicked) {
        return;
      } // EARLY EXIT: If there's an active menu link, don't open accordion
      // This prevents accordion from opening when menu link is active


      var $activeSubNavLink = $(".js__sub-nav-link.active");
      var $activeBigNavLink = $(".js__big-nav-link.active");

      if ($activeSubNavLink.length > 0 || $activeBigNavLink.length > 0) {
        // Check if the active link was clicked very recently (within 1000ms)
        var activeLinkClickTime = $activeSubNavLink.data("click-time") || $activeBigNavLink.data("click-time");

        if (activeLinkClickTime && Date.now() - activeLinkClickTime < 1000) {
          return;
        }
      }

      var $clickTarget = $(e.target);
      var $currentTarget = $(this); // Check the original target and all elements in the event path

      var isMenuLinkClick = false; // Check the original target

      if ($clickTarget.closest(".js__sub-nav-link").length > 0 || $clickTarget.closest(".js__big-nav-link").length > 0 || $clickTarget.is(".js__sub-nav-link") || $clickTarget.is(".js__big-nav-link")) {
        isMenuLinkClick = true;
      } // Check all elements in the event path (composedPath for modern browsers)


      if (e.originalEvent && e.originalEvent.composedPath) {
        var path = e.originalEvent.composedPath();

        for (var i = 0; i < path.length; i++) {
          var $pathElement = $(path[i]);

          if ($pathElement.hasClass("js__sub-nav-link") || $pathElement.hasClass("js__big-nav-link") || $pathElement.closest(".js__sub-nav-link").length > 0 || $pathElement.closest(".js__big-nav-link").length > 0) {
            isMenuLinkClick = true;
            break;
          }
        }
      }

      if (isMenuLinkClick) {
        // Click came from menu link, ignore accordion
        return;
      } // This handles cases where elements overlap due to z-index


      var elementAtPoint = document.elementFromPoint(e.clientX, e.clientY);

      if (elementAtPoint) {
        var $elementAtPoint = $(elementAtPoint); // If the topmost element at click position is a menu link, ignore

        if ($elementAtPoint.closest(".js__sub-nav-link").length > 0 || $elementAtPoint.closest(".js__big-nav-link").length > 0 || $elementAtPoint.is(".js__sub-nav-link") || $elementAtPoint.is(".js__big-nav-link")) {
          return;
        }
      } // Check if a sub-nav or big-nav was just opened (within last 1000ms)
      // This prevents accordion from opening immediately after menu opens


      var $parentSubNav = $currentTarget.closest(".js__sub-nav");
      var $parentBigNav = $currentTarget.closest(".js__big-nav");

      if ($parentSubNav.length > 0 && $parentSubNav.hasClass("active")) {
        var subNavJustOpened = $parentSubNav.data("opened-time");

        if (subNavJustOpened && Date.now() - subNavJustOpened < 1000) {
          return;
        }
      }

      if ($parentBigNav.length > 0 && $parentBigNav.hasClass("active")) {
        var bigNavJustOpened = $parentBigNav.data("opened-time");

        if (bigNavJustOpened && Date.now() - bigNavJustOpened < 1000) {
          return;
        }
      } // Only proceed if click is directly on this accordion element


      if (!$clickTarget.closest($currentTarget).length && !$clickTarget.is($currentTarget)) {
        return;
      }

      e.stopImmediatePropagation();

      if ($(window).width() < 981) {
        if ($(this).hasClass("active")) {
          $(this).removeClass("active");
          $(this).siblings(".accordion-content-inner").slideUp(300);
        } else {
          $(".accordion-toggle-inner").removeClass("active");
          $(this).addClass("active");
          $(".accordion-content-inner").slideUp(300);
          $(this).siblings(".accordion-content-inner").slideDown(300);
        }
      }

      navLink = true;
    }).focus(function (e) {
      "use strict";

      if (navLink) {
        navLink = false;
      } else {
        if ($(window).width() < 981) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }

        if ($(window).width() < 980) {
          if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).siblings(".accordion-content-inner").slideUp(300);
          } else {
            $(".accordion-toggle-inner").removeClass("active");
            $(this).addClass("active");
            $(".accordion-content-inner").slideUp(300);
            $(this).siblings(".accordion-content-inner").slideDown(300);
          }
        }
      }
    });
  });
})(jQuery);
"use strict";

var pdpThumbnail;
var pdpSlider;
$(document).ready(function ($) {
  var producrSlider = new Swiper('.js__pdp-recommendation-slider', {
    slidesPerView: 3,
    autoHeight: true,
    resistance: false,
    shortSwipes: true,
    spaceBetween: 40,
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next-product-recommed',
      prevEl: '.swiper-button-prev-product-recommed'
    },
    breakpoints: {
      0: {
        slidesPerView: 1
      },
      601: {
        slidesPerView: 2
      },
      981: {
        slidesPerView: 3
      }
    }
  });
  pdpSlider = new Swiper(".js__pdp-slider", {
    slidesPerView: 1,
    grabCursor: false,
    mousewheel: false,
    clickable: false,
    resistance: false,
    shortSwipes: true,
    loop: false,
    navigation: {
      nextEl: ".swiper-button-next-pdp",
      prevEl: ".swiper-button-prev-pdp"
    }
  });
  /*PDP tab section drop down change*/

  $(".js__pdp-tab-select").change(function () {
    $(".tab-content").removeClass("active");
    $(".tab-content").hide();
    $("#" + $(this).val()).show();
    $("#" + $(this).val()).addClass("active");
    $(".tab-link").removeClass("active");
    $("#tab-link-" + $(this).val()).addClass("active");
  });
  /* var pdpSlideCount = 0;
   $(document).on("click", ".swiper-button-next-pdp.swiper-button-disabled", function(e) {
           var ariaLabel = $(".js__pdp-slider").find(".swiper-slide-active").attr("aria-label").split("/");
           console.log(ariaLabel[0]);
           console.log(ariaLabel[1]);
           pdpSlideCount++;
           if (pdpSlideCount == 2) {
               if (ariaLabel[0].trim() == ariaLabel[1].trim()) {
                   pdpSlideCount = 0
                   pdpSlider.slideTo(0);
               }
           }
         })*/

  /* Manual click of thumbnail of slider*/

  $(document).on("click", ".pdp-thumbnail li", function (e) {
    var slideno = $(this).index();
    $(".pdp-thumbnail li").removeClass("active");
    $(this).addClass("active");
    $(".pdp-slider").slick("slickGoTo", slideno);
    setTimeout(function () {
      $(".pdp-thumbnail").slick("slickGoTo", slideno);
    }, 500);
    /* var slideno = $(this).index();
             $(".pdp-thumbnail li").removeClass("active");
             $(this).addClass("active");
             console.log("slideno"+slideno);
       
             $(".pdp-slider").slick("slickGoTo", slideno);*/
  });
  /*Slider working End*/

  /* Call page load functions */

  setTimeout(function () {
    setColorThumbImages();
  }, 1000);
  /* FORMATTING: Loop Through each color thumb and set the images for them through the product color library object */

  function setColorThumbImages() {
    if ($(".js-variant-color-swatch li")[0]) {
      $(".js-variant-color-swatch  li").each(function (index) {
        var color = $(this).attr("data-color");
        var colorValue = getVariantColor(color); //$(this).children("div.color").css("background-color", colorValue);

        if (colorValue == "") {
          $(this).children("img").css("opacity", "0");
        }

        $(this).children("img").attr("src", colorValue);
      });
    }
  }
});
/*PENDING Get Variant Color*/

function getVariantColor(color) {
  try {
    var variantColorValue = "";
    $.each(prodColor, function (key, value) {
      if (color.toLowerCase() == value.title.toLowerCase()) {
        variantColorValue = value.color;
      }
    });
    /* $.each(prodLib, function (key, value) {
       if (color.toLowerCase() == value.option1.toLowerCase()) {
         variantColorValue = value.image;
       }
     });*/

    return variantColorValue;
  } catch (_unused) {}
}
/* Color swatch click*/


$(document).ready(function ($) {
  $(document).on("mouseenter", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var variantImage = $(this).attr("data-image");
    var featuredImage = $(this).attr("data-featured_image");

    if (variantImage.indexOf("no-image-") == -1) {
      $(".js__product-image-" + productID).attr("src", variantImage);
    } else {
      $(".js__product-image-" + productID).attr("src", featuredImage);
    }
  });
  $(document).on("mouseleave", ".js__product-cart-color li", function () {
    var productID = $(this).attr("data-product-id");
    var featuredImage = $(".js__product-image-" + productID).attr("data-src");
    $(".js__product-image-" + productID).attr("src", featuredImage);
  });
});
"use strict";

var colorSelected = "";
var secondOptionVariantValue = "";
var thirdOptionVariantValue = "";
var selectedVariantID;
$(document).ready(function ($) {
  /* if no varient then active class added in product image section*/
  if (prodLib.length == 0) {
    $(".js-pdp-media").addClass("active");
    $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
  }

  var colorPosition = $("#colorPosition").val();
  var numberOfAvailableOptions = parseInt($("#optionSize").val()); // on page load check the color position, and set 2nd and 3rd options values

  checkColorPosition();

  function checkColorPosition() {
    getColorPosition();
    /* 
    if only color and no other options
    */

    if (colorPosition != undefined && numberOfAvailableOptions == 1) {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    }
  }
  /*Quantity Plus Minus*/


  $(".js-product-single__quantity .js-plus-minus-qty").click(function () {
    var type = $(this).attr("data-type");
    var productQuantity = $(".js-quantity-selector").val();

    if (type == "minus") {
      if (productQuantity > 1) {
        productQuantity--;
      }
    } else {
      productQuantity++;
    }

    $(".js-quantity-selector").val(productQuantity);
  });
  $('.js__pdp-edit').on('click', function () {
    $('html, body').animate({
      scrollTop: $('.product__information').offset().top - 200
    }, 600);
  }); // On DD change, fire the form DD element and also run the soldoutColorSwatches function

  $(".js__pdp-variant-select").change(function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).val();
    $("#product .product__form .options .option.option-" + optionIndex + " .label span").text(optionValue); // button  - Sold out and add to cart

    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(optionValue);
    }

    var selectedVariant = $("#product-select :selected").text().replace("- sold out!", "");
    $(".js__product-variant-selected").html(selectedVariant); //color swatch - sold out working

    SoldOutUnavailableOnColorSwatches(colorSelected);
  });
  $(document).on("click", ".js__pdp-variant-select li", function () {
    var optionIndex = $(this).attr("data-option");
    var optionValue = $(this).attr("data-value");
    var optionType = $(this).parent("ul").attr("data-type");
    $(this).parent("ul").children("li").removeClass("active");
    $(this).addClass("active");
    $("#product-select-option-" + optionIndex).val(optionValue).trigger("change");
    $("#product-select").change();
    /*Checking if this is filter type then image filter code will work*/

    try {
      var FilterType = $("#variantFilterType").val();

      if (optionType == FilterType) {
        imageFilter(optionValue);
      }
    } catch (_unused) {} // button  - Sold out and add to cart


    try {
      SoldOutUnavailableOnColorSwatches(colorSelected);
    } catch (_unused2) {} //color swatch - sold out working


    $(".variant-section ul").empty();
    $(".variant-option").each(function () {
      var vType = $(this).children(".label").html();
      var vValue = $(this).find("li.active").html();
      $(".variant-section ul").append("<li>" + vType + ": " + vValue + "</li>");
    });
  });
  $(".js__pdp-variant-select li.active").click();
  $(".js__color-swatches").click(function () {
    // remove active class - from all the li's
    $('.js__color-swatches').removeClass('active'); // add class on the one which is clicked

    $(this).addClass('active');
    var optionindex = $(this).data('option');
    var thevalue = $(this).data('value'); //show the selected value

    $('.variant-option.option-' + optionindex + ' .label span').text(thevalue); // trigger change

    $('#product-select-option-' + optionindex).val(thevalue).trigger('change');
    /*Checking if this is filter type then image filter code will work*/

    var OptionType = $(this).parent("ul").attr("data-type");
    var FilterType = $("#variantFilterType").val();

    if (OptionType == FilterType) {
      imageFilter(thevalue);
    }
  });
  /*Run this function when image change on variant click*/

  function imageFilter(selectedValue) {
    /*Slick slider filter on swatch click*/
    var thumbColorSelected = selectedValue.replace(" ", "-");
    thumbColorSelected = thumbColorSelected.replace(/[^a-zA-Z0-9 ]/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/ /g, "-");
    thumbColorSelected = thumbColorSelected.replace(/--/g, "-");
    thumbColorSelected = thumbColorSelected.replace(/---/g, "-"); // $(".pdp-slider").slick("slickUnfilter");
    //   $(".js__pdp-thumbnail-slider").slick("slickUnfilter");

    $(".pdp-slider").find(".all").addClass(thumbColorSelected.toLowerCase());
    $(".js__pdp-thumbnail-slider").find(".all").addClass(thumbColorSelected.toLowerCase()); //   $(".pdp-slider").slick("slickFilter", "." + thumbColorSelected.toLowerCase());
    //  $(".js__pdp-thumbnail-slider").slick( "slickFilter","." + thumbColorSelected.toLowerCase());

    $(".js__pdp-thumbnail-slider .swiper-slide").removeClass("active"); //$(".js__pdp-thumbnail-slider").slick("refresh");

    $(".pdp-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".js__pdp-thumbnail-slider").find(".slide").addClass("remove-slide").removeClass("swiper-slide").removeAttr("aria-label");
    $(".pdp-slider").find(".slide").children(".image-section").removeAttr("data-fancybox");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".js__pdp-thumbnail-slider").find("." + thumbColorSelected.toLowerCase()).removeClass("remove-slide").addClass("swiper-slide");
    $(".pdp-slider").find("." + thumbColorSelected.toLowerCase()).children(".image-section").attr("data-fancybox", "product");
    pdpSlider.destroy();
    pdpSlider = new Swiper(".js__pdp-slider", {
      slidesPerView: 1,
      grabCursor: false,
      mousewheel: false,
      clickable: false,
      resistance: false,
      shortSwipes: true,
      loop: false,
      navigation: {
        nextEl: ".swiper-button-next-pdp",
        prevEl: ".swiper-button-prev-pdp"
      }
    });
    /*Selected first variant image in slider which have no all class*/

    var boolVariantFirstImage = false;
    $(".js__pdp-thumbnail-slider  li").each(function () {
      if (!$(this).hasClass("all")) {
        if (boolVariantFirstImage == false) {
          $(this).click();
          $(this).addClass("active");
          boolVariantFirstImage = true;
        }
      }
    });
    /*When we dont have any variant image*/

    if (boolVariantFirstImage == false) {
      $(".js__pdp-thumbnail-slider li:first-child").addClass("active");
      $(".js__pdp-thumbnail-slider li:first-child").click();
    }

    colorSelected = selectedValue;
  } // main sold out and unavailable working


  function SoldOutUnavailableOnColorSwatches(colorSelected) {
    getColorPosition(); // Remove out of stock and unavailable from color swatches

    $(".js__color-swatches").removeClass("out-of-stock");
    $(".js__color-swatches").removeClass("unavailable");
    var colorLength = $(".js__color-swatches").length;
    var colorCount = 1;
    /*
    Loop Through each input radio for the color
    */
    // we are using color swatch working for other options when they are radio buttons

    $(".js__color-swatches").each(function (index) {
      var colorValue = $(this).attr("data-value");
      var checkColorOptionExists = false;
      /* 
       Loop through product library object for variant 
       and if variant select matches and quantity = 0 then show out of stock message
       */

      /*
      PENDING - Merge - ProdLib Each Function
      */

      $.each(prodLib, function (key, value) {
        var itemQuantity = value.quantity;
        var itemAvailable = value.available;
        var prodColorOptionValue = "";
        var prodSecondOptionValue = "";
        var prodThirdOptionValue = "";

        if (colorPosition == "1") {
          prodColorOptionValue = value.option1;
          prodSecondOptionValue = value.option2;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "2") {
          prodColorOptionValue = value.option2;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option3;
        }

        if (colorPosition == "3") {
          prodColorOptionValue = value.option3;
          prodSecondOptionValue = value.option1;
          prodThirdOptionValue = value.option2;
        }

        var colorOption = prodColorOptionValue.toLowerCase();
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        /*Checking each color  size quantity and which have 0 then added out of stock class*/

        if (numberOfAvailableOptions == 3) {
          /*three matching option checking quantity if 0 then showing out of stock */
          if (secondOptionVariantValue.toLowerCase() == prodSecondOptionValue.toLowerCase() && thirdOptionVariantValue.toLowerCase() == prodThirdOptionValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else if (numberOfAvailableOptions == 2) {
          /*two matching option checking quantity if 0 then showing out of stock */
          if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
            {
              //check if quantity>1 then set the color swatch - Out of stock
              setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
            }
          }
        } else {
          //check if quantity>1 then set the color swatch - Out of stock
          setColorSwatchOutofStock(colorOption, itemQuantity, itemAvailable);
        }

        if (prodColorOptionValue == colorValue) {
          if (numberOfAvailableOptions == 3) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase() && prodThirdOptionValue.toLowerCase() == thirdOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else if (numberOfAvailableOptions == 2) {
            if (prodSecondOptionValue.toLowerCase() == secondOptionVariantValue.toLowerCase()) {
              checkColorOptionExists = true;
            }
          } else {
            checkColorOptionExists = true;
          }
        }
      });

      if (checkColorOptionExists == false) {
        var colorOption = colorValue;
        colorOption = colorOption.replace(/[^a-zA-Z0-9 ]/g, "-");
        colorOption = colorOption.replace(/ /g, "-");
        colorOption = colorOption.replace(/--/g, "-");
        colorOption = colorOption.replace(/---/g, "-");
        colorOption = colorOption.toLowerCase();
        $(".js__color-swatches[data-type-value=" + colorOption + "]").removeClass("out-of-stock");
        $(".js__color-swatches[data-type-value=" + colorOption + "]").addClass("unavailable");

        if ($(".js__color-swatches[data-type-value=" + colorOption + "]").hasClass("active")) {
          var nextColor = colorCount + 1;

          if (colorCount < colorLength) {
            $(".js__color-swatches:nth-child(" + nextColor + ")").click();
          } else {
            $(".js__color-swatches:nth-child(1)").click();
          }
        }
      }

      colorCount++;
    });
  }

  function getColorPosition() {
    if (colorPosition != undefined && numberOfAvailableOptions > 1) {
      if (colorPosition == "1") {
        secondOptionVariantValue = $(".js__pdp-variant-select1").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "2") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select2").val();
        }
      }

      if (colorPosition == "3") {
        secondOptionVariantValue = $(".js__pdp-variant-select0").val();

        if (numberOfAvailableOptions > 2) {
          thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
        }
      }
    } else {
      secondOptionVariantValue = $(".js__pdp-variant-select0").val();

      if (numberOfAvailableOptions > 1) {
        thirdOptionVariantValue = $(".js__pdp-variant-select1").val();
      }
    }

    try {
      colorSelected = colorSelected.toLowerCase();
    } catch (_unused3) {}
  }

  function setColorSwatchOutofStock(prodColor, prodQuantity, prodAvailability) {
    if (prodQuantity < 1 && prodAvailability == "false") {
      $(".js__color-swatches[data-type-value=" + prodColor + "]").addClass("out-of-stock");
    }
  }

  $(window).scroll(function () {
    var sticky = $(".product__media-outer"),
        scroll = $(window).scrollTop();
    var pos = sticky.height();

    if (scroll >= 768 & scroll <= pos - 690) {
      sticky.addClass("fixed"); // $(".main-content").addClass("active");
    } else {
      sticky.removeClass("fixed"); // $(".main-content").removeClass("active");
    }
  }); // show para on click read More button

  $(".js__read-more_btn").click(function () {
    $(".js__read-less-content").addClass("hide");
    $(".js__read-more-content").removeClass("hide");
  });
  $(".js__read-less_btn").click(function () {
    $(".js__read-less-content").removeClass("hide");
    $(".js__read-more-content").addClass("hide");
  });
});